var map = {
	"./ajax-loader.gif": "./public/assets/images/ajax-loader.gif",
	"./avtar/1.jpg": "./public/assets/images/avtar/1.jpg",
	"./avtar/10.jpg": "./public/assets/images/avtar/10.jpg",
	"./avtar/11.jpg": "./public/assets/images/avtar/11.jpg",
	"./avtar/12.jpg": "./public/assets/images/avtar/12.jpg",
	"./avtar/16.jpg": "./public/assets/images/avtar/16.jpg",
	"./avtar/2.jpg": "./public/assets/images/avtar/2.jpg",
	"./avtar/3.jpg": "./public/assets/images/avtar/3.jpg",
	"./avtar/4.jpg": "./public/assets/images/avtar/4.jpg",
	"./avtar/5.jpg": "./public/assets/images/avtar/5.jpg",
	"./avtar/6.jpg": "./public/assets/images/avtar/6.jpg",
	"./avtar/7.jpg": "./public/assets/images/avtar/7.jpg",
	"./avtar/8.jpg": "./public/assets/images/avtar/8.jpg",
	"./avtar/9.jpg": "./public/assets/images/avtar/9.jpg",
	"./avtar/bg-balance.png": "./public/assets/images/avtar/bg-balance.png",
	"./avtar/user.png": "./public/assets/images/avtar/user.png",
	"./banner/1.jpg": "./public/assets/images/banner/1.jpg",
	"./banner/2.jpg": "./public/assets/images/banner/2.jpg",
	"./banner/3.jpg": "./public/assets/images/banner/3.jpg",
	"./big-lightgallry/01.jpg": "./public/assets/images/big-lightgallry/01.jpg",
	"./big-lightgallry/010.jpg": "./public/assets/images/big-lightgallry/010.jpg",
	"./big-lightgallry/011.jpg": "./public/assets/images/big-lightgallry/011.jpg",
	"./big-lightgallry/012.jpg": "./public/assets/images/big-lightgallry/012.jpg",
	"./big-lightgallry/013.jpg": "./public/assets/images/big-lightgallry/013.jpg",
	"./big-lightgallry/014.jpg": "./public/assets/images/big-lightgallry/014.jpg",
	"./big-lightgallry/015.jpg": "./public/assets/images/big-lightgallry/015.jpg",
	"./big-lightgallry/016.jpg": "./public/assets/images/big-lightgallry/016.jpg",
	"./big-lightgallry/02.jpg": "./public/assets/images/big-lightgallry/02.jpg",
	"./big-lightgallry/03.jpg": "./public/assets/images/big-lightgallry/03.jpg",
	"./big-lightgallry/04.jpg": "./public/assets/images/big-lightgallry/04.jpg",
	"./big-lightgallry/05.jpg": "./public/assets/images/big-lightgallry/05.jpg",
	"./big-lightgallry/06.jpg": "./public/assets/images/big-lightgallry/06.jpg",
	"./big-lightgallry/07.jpg": "./public/assets/images/big-lightgallry/07.jpg",
	"./big-lightgallry/08.jpg": "./public/assets/images/big-lightgallry/08.jpg",
	"./big-lightgallry/09.jpg": "./public/assets/images/big-lightgallry/09.jpg",
	"./big-masonry/1.jpg": "./public/assets/images/big-masonry/1.jpg",
	"./big-masonry/10.jpg": "./public/assets/images/big-masonry/10.jpg",
	"./big-masonry/11.jpg": "./public/assets/images/big-masonry/11.jpg",
	"./big-masonry/12.jpg": "./public/assets/images/big-masonry/12.jpg",
	"./big-masonry/13.jpg": "./public/assets/images/big-masonry/13.jpg",
	"./big-masonry/14.jpg": "./public/assets/images/big-masonry/14.jpg",
	"./big-masonry/15.jpg": "./public/assets/images/big-masonry/15.jpg",
	"./big-masonry/2.jpg": "./public/assets/images/big-masonry/2.jpg",
	"./big-masonry/3.jpg": "./public/assets/images/big-masonry/3.jpg",
	"./big-masonry/4.jpg": "./public/assets/images/big-masonry/4.jpg",
	"./big-masonry/5.jpg": "./public/assets/images/big-masonry/5.jpg",
	"./big-masonry/6.jpg": "./public/assets/images/big-masonry/6.jpg",
	"./big-masonry/7.jpg": "./public/assets/images/big-masonry/7.jpg",
	"./big-masonry/8.jpg": "./public/assets/images/big-masonry/8.jpg",
	"./big-masonry/9.jpg": "./public/assets/images/big-masonry/9.jpg",
	"./blog/12.jpg": "./public/assets/images/blog/12.jpg",
	"./blog/14.jpg": "./public/assets/images/blog/14.jpg",
	"./blog/4.jpg": "./public/assets/images/blog/4.jpg",
	"./blog/9.jpg": "./public/assets/images/blog/9.jpg",
	"./blog/blog-2.jpg": "./public/assets/images/blog/blog-2.jpg",
	"./blog/blog-3.jpg": "./public/assets/images/blog/blog-3.jpg",
	"./blog/blog-5.jpg": "./public/assets/images/blog/blog-5.jpg",
	"./blog/blog-6.jpg": "./public/assets/images/blog/blog-6.jpg",
	"./blog/blog-single.jpg": "./public/assets/images/blog/blog-single.jpg",
	"./blog/blog.jpg": "./public/assets/images/blog/blog.jpg",
	"./blog/comment.jpg": "./public/assets/images/blog/comment.jpg",
	"./blog/img.png": "./public/assets/images/blog/img.png",
	"./customizer/brush.png": "./public/assets/images/customizer/brush.png",
	"./customizer/like-tag.png": "./public/assets/images/customizer/like-tag.png",
	"./customizer/medical-kit.png": "./public/assets/images/customizer/medical-kit.png",
	"./customizer/setting-2.png": "./public/assets/images/customizer/setting-2.png",
	"./customizer/setting-5.png": "./public/assets/images/customizer/setting-5.png",
	"./dashboard-2/1.gif": "./public/assets/images/dashboard-2/1.gif",
	"./dashboard-2/bg-shape.png": "./public/assets/images/dashboard-2/bg-shape.png",
	"./dashboard-2/bg.png": "./public/assets/images/dashboard-2/bg.png",
	"./dashboard-2/bg3.gif": "./public/assets/images/dashboard-2/bg3.gif",
	"./dashboard-2/deal-bg.png": "./public/assets/images/dashboard-2/deal-bg.png",
	"./dashboard-2/orders/1.png": "./public/assets/images/dashboard-2/orders/1.png",
	"./dashboard-2/orders/2.png": "./public/assets/images/dashboard-2/orders/2.png",
	"./dashboard-2/product/chair.png": "./public/assets/images/dashboard-2/product/chair.png",
	"./dashboard-2/product/headphone.png": "./public/assets/images/dashboard-2/product/headphone.png",
	"./dashboard-2/product/helmet.png": "./public/assets/images/dashboard-2/product/helmet.png",
	"./dashboard-2/product/tube.png": "./public/assets/images/dashboard-2/product/tube.png",
	"./dashboard-2/vector1.png": "./public/assets/images/dashboard-2/vector1.png",
	"./dashboard-3/1.png": "./public/assets/images/dashboard-3/1.png",
	"./dashboard-3/banner.png": "./public/assets/images/dashboard-3/banner.png",
	"./dashboard-3/bg.png": "./public/assets/images/dashboard-3/bg.png",
	"./dashboard-3/client/1.png": "./public/assets/images/dashboard-3/client/1.png",
	"./dashboard-3/client/2.png": "./public/assets/images/dashboard-3/client/2.png",
	"./dashboard-3/user/1.png": "./public/assets/images/dashboard-3/user/1.png",
	"./dashboard-3/user/10.png": "./public/assets/images/dashboard-3/user/10.png",
	"./dashboard-3/user/11.png": "./public/assets/images/dashboard-3/user/11.png",
	"./dashboard-3/user/12.png": "./public/assets/images/dashboard-3/user/12.png",
	"./dashboard-3/user/13.png": "./public/assets/images/dashboard-3/user/13.png",
	"./dashboard-3/user/14.png": "./public/assets/images/dashboard-3/user/14.png",
	"./dashboard-3/user/15.png": "./public/assets/images/dashboard-3/user/15.png",
	"./dashboard-3/user/16.png": "./public/assets/images/dashboard-3/user/16.png",
	"./dashboard-3/user/17.png": "./public/assets/images/dashboard-3/user/17.png",
	"./dashboard-3/user/18.png": "./public/assets/images/dashboard-3/user/18.png",
	"./dashboard-3/user/19.png": "./public/assets/images/dashboard-3/user/19.png",
	"./dashboard-3/user/2.png": "./public/assets/images/dashboard-3/user/2.png",
	"./dashboard-3/user/3.png": "./public/assets/images/dashboard-3/user/3.png",
	"./dashboard-3/user/4.png": "./public/assets/images/dashboard-3/user/4.png",
	"./dashboard-3/user/5.png": "./public/assets/images/dashboard-3/user/5.png",
	"./dashboard-3/user/6.png": "./public/assets/images/dashboard-3/user/6.png",
	"./dashboard-3/user/7.png": "./public/assets/images/dashboard-3/user/7.png",
	"./dashboard-3/user/8.png": "./public/assets/images/dashboard-3/user/8.png",
	"./dashboard-3/user/9.png": "./public/assets/images/dashboard-3/user/9.png",
	"./dashboard/1.png": "./public/assets/images/dashboard/1.png",
	"./dashboard/banner.png": "./public/assets/images/dashboard/banner.png",
	"./dashboard/bg-1.png": "./public/assets/images/dashboard/bg-1.png",
	"./dashboard/bg.jpg": "./public/assets/images/dashboard/bg.jpg",
	"./dashboard/folder.png": "./public/assets/images/dashboard/folder.png",
	"./dashboard/folder1.png": "./public/assets/images/dashboard/folder1.png",
	"./dashboard/product/1.png": "./public/assets/images/dashboard/product/1.png",
	"./dashboard/product/2.png": "./public/assets/images/dashboard/product/2.png",
	"./dashboard/product/3.png": "./public/assets/images/dashboard/product/3.png",
	"./dashboard/product/4.png": "./public/assets/images/dashboard/product/4.png",
	"./dashboard/product/5.png": "./public/assets/images/dashboard/product/5.png",
	"./dashboard/user/1.jpg": "./public/assets/images/dashboard/user/1.jpg",
	"./dashboard/user/1.png": "./public/assets/images/dashboard/user/1.png",
	"./dashboard/user/10.jpg": "./public/assets/images/dashboard/user/10.jpg",
	"./dashboard/user/11.jpg": "./public/assets/images/dashboard/user/11.jpg",
	"./dashboard/user/12.jpg": "./public/assets/images/dashboard/user/12.jpg",
	"./dashboard/user/13.jpg": "./public/assets/images/dashboard/user/13.jpg",
	"./dashboard/user/2.jpg": "./public/assets/images/dashboard/user/2.jpg",
	"./dashboard/user/3.jpg": "./public/assets/images/dashboard/user/3.jpg",
	"./dashboard/user/4.jpg": "./public/assets/images/dashboard/user/4.jpg",
	"./dashboard/user/5.jpg": "./public/assets/images/dashboard/user/5.jpg",
	"./dashboard/user/6.jpg": "./public/assets/images/dashboard/user/6.jpg",
	"./dashboard/user/7.jpg": "./public/assets/images/dashboard/user/7.jpg",
	"./dashboard/user/8.jpg": "./public/assets/images/dashboard/user/8.jpg",
	"./dashboard/user/9.jpg": "./public/assets/images/dashboard/user/9.jpg",
	"./dashboard/welcome.png": "./public/assets/images/dashboard/welcome.png",
	"./details_close.png": "./public/assets/images/details_close.png",
	"./details_open.png": "./public/assets/images/details_open.png",
	"./ecommerce/01.jpg": "./public/assets/images/ecommerce/01.jpg",
	"./ecommerce/02.jpg": "./public/assets/images/ecommerce/02.jpg",
	"./ecommerce/03.jpg": "./public/assets/images/ecommerce/03.jpg",
	"./ecommerce/04.jpg": "./public/assets/images/ecommerce/04.jpg",
	"./ecommerce/05.jpg": "./public/assets/images/ecommerce/05.jpg",
	"./ecommerce/06.jpg": "./public/assets/images/ecommerce/06.jpg",
	"./ecommerce/07.jpg": "./public/assets/images/ecommerce/07.jpg",
	"./ecommerce/08.jpg": "./public/assets/images/ecommerce/08.jpg",
	"./ecommerce/banner.jpg": "./public/assets/images/ecommerce/banner.jpg",
	"./ecommerce/card.png": "./public/assets/images/ecommerce/card.png",
	"./ecommerce/mastercard.png": "./public/assets/images/ecommerce/mastercard.png",
	"./ecommerce/paypal.png": "./public/assets/images/ecommerce/paypal.png",
	"./ecommerce/product-table-1.png": "./public/assets/images/ecommerce/product-table-1.png",
	"./ecommerce/product-table-2.png": "./public/assets/images/ecommerce/product-table-2.png",
	"./ecommerce/product-table-3.png": "./public/assets/images/ecommerce/product-table-3.png",
	"./ecommerce/product-table-4.png": "./public/assets/images/ecommerce/product-table-4.png",
	"./ecommerce/product-table-5.png": "./public/assets/images/ecommerce/product-table-5.png",
	"./ecommerce/product-table-6.png": "./public/assets/images/ecommerce/product-table-6.png",
	"./ecommerce/visa.png": "./public/assets/images/ecommerce/visa.png",
	"./email-template/1.jpg": "./public/assets/images/email-template/1.jpg",
	"./email-template/1.png": "./public/assets/images/email-template/1.png",
	"./email-template/10.jpg": "./public/assets/images/email-template/10.jpg",
	"./email-template/11.jpg": "./public/assets/images/email-template/11.jpg",
	"./email-template/12.jpg": "./public/assets/images/email-template/12.jpg",
	"./email-template/2.png": "./public/assets/images/email-template/2.png",
	"./email-template/3.png": "./public/assets/images/email-template/3.png",
	"./email-template/4.png": "./public/assets/images/email-template/4.png",
	"./email-template/5.png": "./public/assets/images/email-template/5.png",
	"./email-template/6.png": "./public/assets/images/email-template/6.png",
	"./email-template/7.jpg": "./public/assets/images/email-template/7.jpg",
	"./email-template/7.png": "./public/assets/images/email-template/7.png",
	"./email-template/8.jpg": "./public/assets/images/email-template/8.jpg",
	"./email-template/8.png": "./public/assets/images/email-template/8.png",
	"./email-template/banner-2.jpg": "./public/assets/images/email-template/banner-2.jpg",
	"./email-template/banner.jpg": "./public/assets/images/email-template/banner.jpg",
	"./email-template/cosmetic.jpg": "./public/assets/images/email-template/cosmetic.jpg",
	"./email-template/delivery-2.png": "./public/assets/images/email-template/delivery-2.png",
	"./email-template/delivery.png": "./public/assets/images/email-template/delivery.png",
	"./email-template/facebook.png": "./public/assets/images/email-template/facebook.png",
	"./email-template/gplus.png": "./public/assets/images/email-template/gplus.png",
	"./email-template/invoice-1/1.png": "./public/assets/images/email-template/invoice-1/1.png",
	"./email-template/invoice-1/sign.png": "./public/assets/images/email-template/invoice-1/sign.png",
	"./email-template/invoice-3/bg-0.png": "./public/assets/images/email-template/invoice-3/bg-0.png",
	"./email-template/invoice-3/sign.png": "./public/assets/images/email-template/invoice-3/sign.png",
	"./email-template/linkedin.png": "./public/assets/images/email-template/linkedin.png",
	"./email-template/order-success.png": "./public/assets/images/email-template/order-success.png",
	"./email-template/pdfs.png": "./public/assets/images/email-template/pdfs.png",
	"./email-template/pinterest.png": "./public/assets/images/email-template/pinterest.png",
	"./email-template/slider.jpg": "./public/assets/images/email-template/slider.jpg",
	"./email-template/space.jpg": "./public/assets/images/email-template/space.jpg",
	"./email-template/success.png": "./public/assets/images/email-template/success.png",
	"./email-template/twitter.png": "./public/assets/images/email-template/twitter.png",
	"./email-template/youtube.png": "./public/assets/images/email-template/youtube.png",
	"./email/3.jpg": "./public/assets/images/email/3.jpg",
	"./faq/1.jpg": "./public/assets/images/faq/1.jpg",
	"./faq/2.jpg": "./public/assets/images/faq/2.jpg",
	"./faq/3.jpg": "./public/assets/images/faq/3.jpg",
	"./faq/4.jpg": "./public/assets/images/faq/4.jpg",
	"./faq/learning-1.png": "./public/assets/images/faq/learning-1.png",
	"./favicon.png": "./public/assets/images/favicon.png",
	"./forms/Bank-of-Baroda.png": "./public/assets/images/forms/Bank-of-Baroda.png",
	"./forms/SCB.png": "./public/assets/images/forms/SCB.png",
	"./forms/authenticate.png": "./public/assets/images/forms/authenticate.png",
	"./forms/axis.png": "./public/assets/images/forms/axis.png",
	"./forms/credit-card.png": "./public/assets/images/forms/credit-card.png",
	"./forms/delivery.png": "./public/assets/images/forms/delivery.png",
	"./forms/email.png": "./public/assets/images/forms/email.png",
	"./forms/flags.png": "./public/assets/images/forms/flags.png",
	"./forms/hdfc.png": "./public/assets/images/forms/hdfc.png",
	"./forms/idbi.png": "./public/assets/images/forms/idbi.png",
	"./forms/qr-code.png": "./public/assets/images/forms/qr-code.png",
	"./forms/qr-scan.png": "./public/assets/images/forms/qr-scan.png",
	"./forms/rbl.png": "./public/assets/images/forms/rbl.png",
	"./forms/us-bank.png": "./public/assets/images/forms/us-bank.png",
	"./forms/user.png": "./public/assets/images/forms/user.png",
	"./gif/danger.gif": "./public/assets/images/gif/danger.gif",
	"./gif/facebook.gif": "./public/assets/images/gif/facebook.gif",
	"./gif/instagram.gif": "./public/assets/images/gif/instagram.gif",
	"./gif/logout.gif": "./public/assets/images/gif/logout.gif",
	"./gif/online-shopping.gif": "./public/assets/images/gif/online-shopping.gif",
	"./gif/sad.gif": "./public/assets/images/gif/sad.gif",
	"./gif/successful.gif": "./public/assets/images/gif/successful.gif",
	"./gif/whatapp.gif": "./public/assets/images/gif/whatapp.gif",
	"./giftools.gif": "./public/assets/images/giftools.gif",
	"./hour.svg": "./public/assets/images/hour.svg",
	"./job-search/1.jpg": "./public/assets/images/job-search/1.jpg",
	"./job-search/2.jpg": "./public/assets/images/job-search/2.jpg",
	"./job-search/3.jpg": "./public/assets/images/job-search/3.jpg",
	"./job-search/4.jpg": "./public/assets/images/job-search/4.jpg",
	"./job-search/5.jpg": "./public/assets/images/job-search/5.jpg",
	"./job-search/6.jpg": "./public/assets/images/job-search/6.jpg",
	"./js-grid.png": "./public/assets/images/js-grid.png",
	"./knowledgebase/bg_1.jpg": "./public/assets/images/knowledgebase/bg_1.jpg",
	"./landing/app/bookmark.jpg": "./public/assets/images/landing/app/bookmark.jpg",
	"./landing/app/chat.jpg": "./public/assets/images/landing/app/chat.jpg",
	"./landing/app/contacts.jpg": "./public/assets/images/landing/app/contacts.jpg",
	"./landing/app/e-commerce.jpg": "./public/assets/images/landing/app/e-commerce.jpg",
	"./landing/app/file.jpg": "./public/assets/images/landing/app/file.jpg",
	"./landing/app/kanban.jpg": "./public/assets/images/landing/app/kanban.jpg",
	"./landing/app/letterbox.jpg": "./public/assets/images/landing/app/letterbox.jpg",
	"./landing/app/project.jpg": "./public/assets/images/landing/app/project.jpg",
	"./landing/app/social-app.jpg": "./public/assets/images/landing/app/social-app.jpg",
	"./landing/app/task.jpg": "./public/assets/images/landing/app/task.jpg",
	"./landing/app/todo.jpg": "./public/assets/images/landing/app/todo.jpg",
	"./landing/app/user.jpg": "./public/assets/images/landing/app/user.jpg",
	"./landing/bg-widget.png": "./public/assets/images/landing/bg-widget.png",
	"./landing/card-1.png": "./public/assets/images/landing/card-1.png",
	"./landing/card-2.png": "./public/assets/images/landing/card-2.png",
	"./landing/card-3.png": "./public/assets/images/landing/card-3.png",
	"./landing/cards.png": "./public/assets/images/landing/cards.png",
	"./landing/charts.jpg": "./public/assets/images/landing/charts.jpg",
	"./landing/color-picker.png": "./public/assets/images/landing/color-picker.png",
	"./landing/customize/customizer.png": "./public/assets/images/landing/customize/customizer.png",
	"./landing/customize/customizer12.png": "./public/assets/images/landing/customize/customizer12.png",
	"./landing/customize/mix-layout.png": "./public/assets/images/landing/customize/mix-layout.png",
	"./landing/customize/mix-layout1.png": "./public/assets/images/landing/customize/mix-layout1.png",
	"./landing/dashboard.png": "./public/assets/images/landing/dashboard.png",
	"./landing/decore/arrow.svg": "./public/assets/images/landing/decore/arrow.svg",
	"./landing/doc.png": "./public/assets/images/landing/doc.png",
	"./landing/feature-icon/1.svg": "./public/assets/images/landing/feature-icon/1.svg",
	"./landing/feature-icon/2.svg": "./public/assets/images/landing/feature-icon/2.svg",
	"./landing/feature-icon/3.svg": "./public/assets/images/landing/feature-icon/3.svg",
	"./landing/feature-icon/4.svg": "./public/assets/images/landing/feature-icon/4.svg",
	"./landing/feature-icon/5.svg": "./public/assets/images/landing/feature-icon/5.svg",
	"./landing/feature-icon/6.svg": "./public/assets/images/landing/feature-icon/6.svg",
	"./landing/feature-icon/7.svg": "./public/assets/images/landing/feature-icon/7.svg",
	"./landing/feature-icon/8.svg": "./public/assets/images/landing/feature-icon/8.svg",
	"./landing/footer.png": "./public/assets/images/landing/footer.png",
	"./landing/framework/angular/Chartist.png": "./public/assets/images/landing/framework/angular/Chartist.png",
	"./landing/framework/angular/Ecommerce.png": "./public/assets/images/landing/framework/angular/Ecommerce.png",
	"./landing/framework/angular/Ng- Bootstrap.png": "./public/assets/images/landing/framework/angular/Ng- Bootstrap.png",
	"./landing/framework/angular/Router.png": "./public/assets/images/landing/framework/angular/Router.png",
	"./landing/framework/angular/Typescript.png": "./public/assets/images/landing/framework/angular/Typescript.png",
	"./landing/framework/angular/gallery.png": "./public/assets/images/landing/framework/angular/gallery.png",
	"./landing/framework/angular/jQuery.png": "./public/assets/images/landing/framework/angular/jQuery.png",
	"./landing/framework/angular/logo.png": "./public/assets/images/landing/framework/angular/logo.png",
	"./landing/framework/angular/map.png": "./public/assets/images/landing/framework/angular/map.png",
	"./landing/framework/angular/ng-apexcharts.png": "./public/assets/images/landing/framework/angular/ng-apexcharts.png",
	"./landing/framework/angular/ng-chatist.png": "./public/assets/images/landing/framework/angular/ng-chatist.png",
	"./landing/framework/angular/ng-google-charts.png": "./public/assets/images/landing/framework/angular/ng-google-charts.png",
	"./landing/framework/angular/ngx- translate.png": "./public/assets/images/landing/framework/angular/ngx- translate.png",
	"./landing/framework/angular/scss.png": "./public/assets/images/landing/framework/angular/scss.png",
	"./landing/framework/html/1.png": "./public/assets/images/landing/framework/html/1.png",
	"./landing/framework/html/10.png": "./public/assets/images/landing/framework/html/10.png",
	"./landing/framework/html/11.png": "./public/assets/images/landing/framework/html/11.png",
	"./landing/framework/html/12.png": "./public/assets/images/landing/framework/html/12.png",
	"./landing/framework/html/14.png": "./public/assets/images/landing/framework/html/14.png",
	"./landing/framework/html/15.png": "./public/assets/images/landing/framework/html/15.png",
	"./landing/framework/html/2.png": "./public/assets/images/landing/framework/html/2.png",
	"./landing/framework/html/3.png": "./public/assets/images/landing/framework/html/3.png",
	"./landing/framework/html/4.png": "./public/assets/images/landing/framework/html/4.png",
	"./landing/framework/html/5.png": "./public/assets/images/landing/framework/html/5.png",
	"./landing/framework/html/7.png": "./public/assets/images/landing/framework/html/7.png",
	"./landing/framework/html/8.png": "./public/assets/images/landing/framework/html/8.png",
	"./landing/framework/html/9.png": "./public/assets/images/landing/framework/html/9.png",
	"./landing/framework/next/Charts.png": "./public/assets/images/landing/framework/next/Charts.png",
	"./landing/framework/next/Crud.png": "./public/assets/images/landing/framework/next/Crud.png",
	"./landing/framework/next/Ecommerce.png": "./public/assets/images/landing/framework/next/Ecommerce.png",
	"./landing/framework/next/React-i18next.png": "./public/assets/images/landing/framework/next/React-i18next.png",
	"./landing/framework/next/React-icon.png": "./public/assets/images/landing/framework/next/React-icon.png",
	"./landing/framework/next/React-redux.png": "./public/assets/images/landing/framework/next/React-redux.png",
	"./landing/framework/next/Reactstrap.png": "./public/assets/images/landing/framework/next/Reactstrap.png",
	"./landing/framework/next/Typescript.png": "./public/assets/images/landing/framework/next/Typescript.png",
	"./landing/framework/next/apps.png": "./public/assets/images/landing/framework/next/apps.png",
	"./landing/framework/next/chat.png": "./public/assets/images/landing/framework/next/chat.png",
	"./landing/framework/next/formik.png": "./public/assets/images/landing/framework/next/formik.png",
	"./landing/framework/next/jQuery.png": "./public/assets/images/landing/framework/next/jQuery.png",
	"./landing/framework/next/next.png": "./public/assets/images/landing/framework/next/next.png",
	"./landing/framework/next/npm.png": "./public/assets/images/landing/framework/next/npm.png",
	"./landing/framework/next/scss.png": "./public/assets/images/landing/framework/next/scss.png",
	"./landing/framework/react/9+ App.png": "./public/assets/images/landing/framework/react/9+ App.png",
	"./landing/framework/react/Charts.png": "./public/assets/images/landing/framework/react/Charts.png",
	"./landing/framework/react/Crud.png": "./public/assets/images/landing/framework/react/Crud.png",
	"./landing/framework/react/React-hook.png": "./public/assets/images/landing/framework/react/React-hook.png",
	"./landing/framework/react/React-i18next.png": "./public/assets/images/landing/framework/react/React-i18next.png",
	"./landing/framework/react/React-icon.png": "./public/assets/images/landing/framework/react/React-icon.png",
	"./landing/framework/react/React-icons.png": "./public/assets/images/landing/framework/react/React-icons.png",
	"./landing/framework/react/React-redux.png": "./public/assets/images/landing/framework/react/React-redux.png",
	"./landing/framework/react/React-router.png": "./public/assets/images/landing/framework/react/React-router.png",
	"./landing/framework/react/Reactstrap.png": "./public/assets/images/landing/framework/react/Reactstrap.png",
	"./landing/framework/react/Typescript.png": "./public/assets/images/landing/framework/react/Typescript.png",
	"./landing/framework/react/bootstrap.png": "./public/assets/images/landing/framework/react/bootstrap.png",
	"./landing/framework/react/gallery.png": "./public/assets/images/landing/framework/react/gallery.png",
	"./landing/framework/react/map.png": "./public/assets/images/landing/framework/react/map.png",
	"./landing/framework/react/scss.png": "./public/assets/images/landing/framework/react/scss.png",
	"./landing/home-bg.jpg": "./public/assets/images/landing/home-bg.jpg",
	"./landing/icon/angular/angular.png": "./public/assets/images/landing/icon/angular/angular.png",
	"./landing/icon/bootstrap.png": "./public/assets/images/landing/icon/bootstrap.png",
	"./landing/icon/gulp.png": "./public/assets/images/landing/icon/gulp.png",
	"./landing/icon/html/html.png": "./public/assets/images/landing/icon/html/html.png",
	"./landing/icon/jquery.png": "./public/assets/images/landing/icon/jquery.png",
	"./landing/icon/minus.svg": "./public/assets/images/landing/icon/minus.svg",
	"./landing/icon/next/15.svg": "./public/assets/images/landing/icon/next/15.svg",
	"./landing/icon/next/next.png": "./public/assets/images/landing/icon/next/next.png",
	"./landing/icon/plus.svg": "./public/assets/images/landing/icon/plus.svg",
	"./landing/icon/react/react.png": "./public/assets/images/landing/icon/react/react.png",
	"./landing/icon/right.svg": "./public/assets/images/landing/icon/right.svg",
	"./landing/icon/sass.png": "./public/assets/images/landing/icon/sass.png",
	"./landing/layout-images/chat-app.png": "./public/assets/images/landing/layout-images/chat-app.png",
	"./landing/layout-images/customer.png": "./public/assets/images/landing/layout-images/customer.png",
	"./landing/layout-images/default.png": "./public/assets/images/landing/layout-images/default.png",
	"./landing/layout-images/default1.png": "./public/assets/images/landing/layout-images/default1.png",
	"./landing/layout-images/devlopment.png": "./public/assets/images/landing/layout-images/devlopment.png",
	"./landing/layout-images/e-chart.png": "./public/assets/images/landing/layout-images/e-chart.png",
	"./landing/layout-images/earning.png": "./public/assets/images/landing/layout-images/earning.png",
	"./landing/layout-images/ecommerce.png": "./public/assets/images/landing/layout-images/ecommerce.png",
	"./landing/layout-images/progress.png": "./public/assets/images/landing/layout-images/progress.png",
	"./landing/layout-images/project.png": "./public/assets/images/landing/layout-images/project.png",
	"./landing/line.png": "./public/assets/images/landing/line.png",
	"./landing/line2.png": "./public/assets/images/landing/line2.png",
	"./landing/locate.png": "./public/assets/images/landing/locate.png",
	"./landing/mobile-layout.png": "./public/assets/images/landing/mobile-layout.png",
	"./landing/project overview.png": "./public/assets/images/landing/project overview.png",
	"./landing/screen1.png": "./public/assets/images/landing/screen1.png",
	"./landing/section-bg.jpg": "./public/assets/images/landing/section-bg.jpg",
	"./landing/support-bg.png": "./public/assets/images/landing/support-bg.png",
	"./landing/support.png": "./public/assets/images/landing/support.png",
	"./landing/svg/1.svg": "./public/assets/images/landing/svg/1.svg",
	"./landing/svg/2.svg": "./public/assets/images/landing/svg/2.svg",
	"./landing/svg/3.svg": "./public/assets/images/landing/svg/3.svg",
	"./landing/svg/4.svg": "./public/assets/images/landing/svg/4.svg",
	"./landing/users/quote.png": "./public/assets/images/landing/users/quote.png",
	"./landing/users/user1.png": "./public/assets/images/landing/users/user1.png",
	"./landing/users/user2.png": "./public/assets/images/landing/users/user2.png",
	"./landing/users/user3.png": "./public/assets/images/landing/users/user3.png",
	"./landing/vector.png": "./public/assets/images/landing/vector.png",
	"./lightgallry/01.jpg": "./public/assets/images/lightgallry/01.jpg",
	"./lightgallry/010.jpg": "./public/assets/images/lightgallry/010.jpg",
	"./lightgallry/011.jpg": "./public/assets/images/lightgallry/011.jpg",
	"./lightgallry/012.jpg": "./public/assets/images/lightgallry/012.jpg",
	"./lightgallry/013.jpg": "./public/assets/images/lightgallry/013.jpg",
	"./lightgallry/014.jpg": "./public/assets/images/lightgallry/014.jpg",
	"./lightgallry/015.jpg": "./public/assets/images/lightgallry/015.jpg",
	"./lightgallry/016.jpg": "./public/assets/images/lightgallry/016.jpg",
	"./lightgallry/02.jpg": "./public/assets/images/lightgallry/02.jpg",
	"./lightgallry/03.jpg": "./public/assets/images/lightgallry/03.jpg",
	"./lightgallry/04.jpg": "./public/assets/images/lightgallry/04.jpg",
	"./lightgallry/05.jpg": "./public/assets/images/lightgallry/05.jpg",
	"./lightgallry/06.jpg": "./public/assets/images/lightgallry/06.jpg",
	"./lightgallry/07.jpg": "./public/assets/images/lightgallry/07.jpg",
	"./lightgallry/08.jpg": "./public/assets/images/lightgallry/08.jpg",
	"./lightgallry/09.jpg": "./public/assets/images/lightgallry/09.jpg",
	"./lightgallry/default-skin.png": "./public/assets/images/lightgallry/default-skin.png",
	"./lightgallry/default-skin.svg": "./public/assets/images/lightgallry/default-skin.svg",
	"./login/1.jpg": "./public/assets/images/login/1.jpg",
	"./login/2.jpg": "./public/assets/images/login/2.jpg",
	"./login/3.jpg": "./public/assets/images/login/3.jpg",
	"./login/icon.png": "./public/assets/images/login/icon.png",
	"./login/login_bg.jpg": "./public/assets/images/login/login_bg.jpg",
	"./logo/logo-icon.png": "./public/assets/images/logo/logo-icon.png",
	"./logo/logo.png": "./public/assets/images/logo/logo.png",
	"./logo/logo_dark.png": "./public/assets/images/logo/logo_dark.png",
	"./marker-icon-2x.png": "./public/assets/images/marker-icon-2x.png",
	"./marker-icon.png": "./public/assets/images/marker-icon.png",
	"./marker-shadow.png": "./public/assets/images/marker-shadow.png",
	"./masonry/1.jpg": "./public/assets/images/masonry/1.jpg",
	"./masonry/10.jpg": "./public/assets/images/masonry/10.jpg",
	"./masonry/11.jpg": "./public/assets/images/masonry/11.jpg",
	"./masonry/12.jpg": "./public/assets/images/masonry/12.jpg",
	"./masonry/13.jpg": "./public/assets/images/masonry/13.jpg",
	"./masonry/14.jpg": "./public/assets/images/masonry/14.jpg",
	"./masonry/15.jpg": "./public/assets/images/masonry/15.jpg",
	"./masonry/2.jpg": "./public/assets/images/masonry/2.jpg",
	"./masonry/3.jpg": "./public/assets/images/masonry/3.jpg",
	"./masonry/4.jpg": "./public/assets/images/masonry/4.jpg",
	"./masonry/5.jpg": "./public/assets/images/masonry/5.jpg",
	"./masonry/6.jpg": "./public/assets/images/masonry/6.jpg",
	"./masonry/7.jpg": "./public/assets/images/masonry/7.jpg",
	"./masonry/8.jpg": "./public/assets/images/masonry/8.jpg",
	"./masonry/9.jpg": "./public/assets/images/masonry/9.jpg",
	"./min.svg": "./public/assets/images/min.svg",
	"./modal/balance.png": "./public/assets/images/modal/balance.png",
	"./modal/learning.png": "./public/assets/images/modal/learning.png",
	"./modal/social.png": "./public/assets/images/modal/social.png",
	"./other-images/bg-profile.png": "./public/assets/images/other-images/bg-profile.png",
	"./other-images/boxbg.jpg": "./public/assets/images/other-images/boxbg.jpg",
	"./other-images/cart-img-1.jpg": "./public/assets/images/other-images/cart-img-1.jpg",
	"./other-images/cart-img.jpg": "./public/assets/images/other-images/cart-img.jpg",
	"./other-images/cart-img2.jpg": "./public/assets/images/other-images/cart-img2.jpg",
	"./other-images/coming-soon-bg.jpg": "./public/assets/images/other-images/coming-soon-bg.jpg",
	"./other-images/header-bg.svg": "./public/assets/images/other-images/header-bg.svg",
	"./other-images/img-cropper.jpg": "./public/assets/images/other-images/img-cropper.jpg",
	"./other-images/logo-login-dark.png": "./public/assets/images/other-images/logo-login-dark.png",
	"./other-images/logo-login.png": "./public/assets/images/other-images/logo-login.png",
	"./other-images/maintenance-bg.jpg": "./public/assets/images/other-images/maintenance-bg.jpg",
	"./other-images/mountain.jpg": "./public/assets/images/other-images/mountain.jpg",
	"./other-images/paypal.png": "./public/assets/images/other-images/paypal.png",
	"./other-images/paypal1.png": "./public/assets/images/other-images/paypal1.png",
	"./other-images/profile-bg.png": "./public/assets/images/other-images/profile-bg.png",
	"./other-images/profile-style-img.png": "./public/assets/images/other-images/profile-style-img.png",
	"./other-images/profile-style-img3.png": "./public/assets/images/other-images/profile-style-img3.png",
	"./other-images/sad.png": "./public/assets/images/other-images/sad.png",
	"./other-images/sea.jpg": "./public/assets/images/other-images/sea.jpg",
	"./other-images/sidebar-bg.jpg": "./public/assets/images/other-images/sidebar-bg.jpg",
	"./product/1.png": "./public/assets/images/product/1.png",
	"./product/10.png": "./public/assets/images/product/10.png",
	"./product/11.png": "./public/assets/images/product/11.png",
	"./product/12.png": "./public/assets/images/product/12.png",
	"./product/13.png": "./public/assets/images/product/13.png",
	"./product/14.png": "./public/assets/images/product/14.png",
	"./product/15.png": "./public/assets/images/product/15.png",
	"./product/2.png": "./public/assets/images/product/2.png",
	"./product/3.png": "./public/assets/images/product/3.png",
	"./product/4.png": "./public/assets/images/product/4.png",
	"./product/category/1.png": "./public/assets/images/product/category/1.png",
	"./product/category/2.png": "./public/assets/images/product/category/2.png",
	"./product/category/3.png": "./public/assets/images/product/category/3.png",
	"./product/category/4.png": "./public/assets/images/product/category/4.png",
	"./product/category/5.png": "./public/assets/images/product/category/5.png",
	"./product/category/purse.png": "./public/assets/images/product/category/purse.png",
	"./product/category/shoes.png": "./public/assets/images/product/category/shoes.png",
	"./product/category/toy.png": "./public/assets/images/product/category/toy.png",
	"./product/order-trash.gif": "./public/assets/images/product/order-trash.gif",
	"./product/product-categories/dvd.png": "./public/assets/images/product/product-categories/dvd.png",
	"./product/product-categories/headphone.png": "./public/assets/images/product/product-categories/headphone.png",
	"./product/product-categories/ipad.png": "./public/assets/images/product/product-categories/ipad.png",
	"./product/product-categories/laptop.png": "./public/assets/images/product/product-categories/laptop.png",
	"./product/product-categories/mouse.png": "./public/assets/images/product/product-categories/mouse.png",
	"./product/product-categories/phone.png": "./public/assets/images/product/product-categories/phone.png",
	"./product/product-categories/speaker.png": "./public/assets/images/product/product-categories/speaker.png",
	"./product/product-categories/watch.png": "./public/assets/images/product/product-categories/watch.png",
	"./product/product-categories/wireless-headphone.png": "./public/assets/images/product/product-categories/wireless-headphone.png",
	"./product/products/1.png": "./public/assets/images/product/products/1.png",
	"./product/products/2.png": "./public/assets/images/product/products/2.png",
	"./product/products/3.png": "./public/assets/images/product/products/3.png",
	"./range-slider/sprite-skin-modern.png": "./public/assets/images/range-slider/sprite-skin-modern.png",
	"./scrollbar/fashion1.jpg": "./public/assets/images/scrollbar/fashion1.jpg",
	"./scrollbar/fashion2.jpg": "./public/assets/images/scrollbar/fashion2.jpg",
	"./scrollbar/fashion3.jpg": "./public/assets/images/scrollbar/fashion3.jpg",
	"./scrollbar/fashion4.jpg": "./public/assets/images/scrollbar/fashion4.jpg",
	"./scrollbar/fashion5.jpg": "./public/assets/images/scrollbar/fashion5.jpg",
	"./scrollbar/fashion6.jpg": "./public/assets/images/scrollbar/fashion6.jpg",
	"./sec.svg": "./public/assets/images/sec.svg",
	"./slider/1.jpg": "./public/assets/images/slider/1.jpg",
	"./slider/10.jpg": "./public/assets/images/slider/10.jpg",
	"./slider/11.jpg": "./public/assets/images/slider/11.jpg",
	"./slider/2.jpg": "./public/assets/images/slider/2.jpg",
	"./slider/3.jpg": "./public/assets/images/slider/3.jpg",
	"./slider/4.jpg": "./public/assets/images/slider/4.jpg",
	"./slider/5.jpg": "./public/assets/images/slider/5.jpg",
	"./slider/6.jpg": "./public/assets/images/slider/6.jpg",
	"./slider/7.jpg": "./public/assets/images/slider/7.jpg",
	"./slider/8.jpg": "./public/assets/images/slider/8.jpg",
	"./slider/9.jpg": "./public/assets/images/slider/9.jpg",
	"./smiley.png": "./public/assets/images/smiley.png",
	"./social-app/post-1.png": "./public/assets/images/social-app/post-1.png",
	"./social-app/post-2.png": "./public/assets/images/social-app/post-2.png",
	"./social-app/post-3.png": "./public/assets/images/social-app/post-3.png",
	"./social-app/post-4.png": "./public/assets/images/social-app/post-4.png",
	"./social-app/post-5.png": "./public/assets/images/social-app/post-5.png",
	"./social-app/post-6.png": "./public/assets/images/social-app/post-6.png",
	"./social-app/post-7.png": "./public/assets/images/social-app/post-7.png",
	"./social-app/post-8.png": "./public/assets/images/social-app/post-8.png",
	"./social-app/post-9.png": "./public/assets/images/social-app/post-9.png",
	"./social-app/social-image.png": "./public/assets/images/social-app/social-image.png",
	"./social-app/timeline-1.png": "./public/assets/images/social-app/timeline-1.png",
	"./social-app/timeline-2.png": "./public/assets/images/social-app/timeline-2.png",
	"./social-app/timeline-3.png": "./public/assets/images/social-app/timeline-3.png",
	"./social-app/timeline-4.png": "./public/assets/images/social-app/timeline-4.png",
	"./sort_asc.png": "./public/assets/images/sort_asc.png",
	"./sort_asc_disabled.png": "./public/assets/images/sort_asc_disabled.png",
	"./sort_both.png": "./public/assets/images/sort_both.png",
	"./sort_desc.png": "./public/assets/images/sort_desc.png",
	"./sort_desc_disabled.png": "./public/assets/images/sort_desc_disabled.png",
	"./start-conversion.jpg": "./public/assets/images/start-conversion.jpg",
	"./switch/1.jpg": "./public/assets/images/switch/1.jpg",
	"./switch/2.jpg": "./public/assets/images/switch/2.jpg",
	"./switch/3.jpg": "./public/assets/images/switch/3.jpg",
	"./switch/4.jpg": "./public/assets/images/switch/4.jpg",
	"./switch/5.jpg": "./public/assets/images/switch/5.jpg",
	"./switch/6.jpg": "./public/assets/images/switch/6.jpg",
	"./switch/7.jpg": "./public/assets/images/switch/7.jpg",
	"./switch/8.jpg": "./public/assets/images/switch/8.jpg",
	"./switch/square-gray.png": "./public/assets/images/switch/square-gray.png",
	"./switch/square.svg": "./public/assets/images/switch/square.svg",
	"./tree/32px.png": "./public/assets/images/tree/32px.png",
	"./tree/40px.png": "./public/assets/images/tree/40px.png",
	"./tree/throbber.gif": "./public/assets/images/tree/throbber.gif",
	"./user-card/5.jpg": "./public/assets/images/user-card/5.jpg",
	"./user.png": "./public/assets/images/user.png",
	"./user/1.jpg": "./public/assets/images/user/1.jpg",
	"./user/10.jpg": "./public/assets/images/user/10.jpg",
	"./user/11.png": "./public/assets/images/user/11.png",
	"./user/12.png": "./public/assets/images/user/12.png",
	"./user/14.png": "./public/assets/images/user/14.png",
	"./user/2.jpg": "./public/assets/images/user/2.jpg",
	"./user/2.png": "./public/assets/images/user/2.png",
	"./user/3.jpg": "./public/assets/images/user/3.jpg",
	"./user/3.png": "./public/assets/images/user/3.png",
	"./user/4.jpg": "./public/assets/images/user/4.jpg",
	"./user/5.jpg": "./public/assets/images/user/5.jpg",
	"./user/6.jpg": "./public/assets/images/user/6.jpg",
	"./user/7.jpg": "./public/assets/images/user/7.jpg",
	"./user/8.jpg": "./public/assets/images/user/8.jpg",
	"./user/9.jpg": "./public/assets/images/user/9.jpg",
	"./user/user.png": "./public/assets/images/user/user.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./public/assets/images sync recursive ^\\.\\/.*$";